import React from "react";
import { Stack, Typography } from "@mui/material";
import ExpandableAccordion from "../../ExpandableAccordion";
import Button from "../../Button";
import PasswordInput from "../../PasswordInput";
import { ASSETS } from "../../../utils/config";
import KeyList from "./Keylist";

const PasswordAccordion = ({
  password,
  setPassword,
  generateKeyPress,
  addKeyToList,
  keys,
  toggleIsActive,
  setKeys,
}) => {
  return (
    <ExpandableAccordion
      isExpanded={true}
      titleIcon={ASSETS.lockIcon}
      title={"Generate Password"}
      subtitle={
        "Visitors will have to enter your Password to view your Wheel."
      }
      childrenStyle={{ pl: 4 }}
    >
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <Stack gap={1} direction={"row"}>
            <div>
              <Button onClick={generateKeyPress} style={{ height: 40 }}>
                <Typography>Generate Key</Typography>
              </Button>
            </div>
            <Stack>
              <PasswordInput
                password={password}
                onChange={(value) => setPassword(value.replace(/\s/g, ""))}
                onCheckPress={addKeyToList}
                placeholder="Minimum 8 Characters"
              />

              {keys?.length > 0 && (
                <div>
                  <ExpandableAccordion
                    titleStyle={{
                      color: "#0F52BA",
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                      fontSize: "0.75rem",
                    }}
                    AccordionSummaryStyle={{
                      minHeight: 30,
                      p: 0,
                      m: 0,
                    }}
                    title={"See previous keys"}
                    isExpanded={true}
                  >
                    <KeyList
                      toggleIsActive={toggleIsActive}
                      keys={keys}
                      setKeys={setKeys}
                    />
                  </ExpandableAccordion>
                </div>
              )}
            </Stack>
          </Stack>
        </div>
      </div>
    </ExpandableAccordion>
  );
};

export default PasswordAccordion;
